module.exports = __webpack_public_path__ + "img/EWMA-District-Logo-Transparent@3x.4c3c1d64.png";